import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AuthService } from '../../../auth/services/auth.service';
import { SharedModule } from '../../../../../shared/shared.module';
import { AuthenticatorService } from '../../services/authenticator.service';



@Component({
  selector: 'app-two-factor',
  templateUrl: './two-factor.component.html',
  styleUrls: ['./two-factor.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class TwoFactorComponent implements OnInit {
  username: string;
  qrImage: string | null = null;
  secret: string | null = null;
  codigo = '';
  verified = false;
  message = '';
  loading = false;

  tiene2FA = false; // 🔹 nuevo estado lógico

  // modo: "login" o "setup"
  modo: 'login' | 'setup' = 'login';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<TwoFactorComponent>,
    private readonly authenticatorService: AuthenticatorService,
    private readonly authService: AuthService
  ) {
    this.username = data?.username || '';
    this.modo = data?.modo || 'login';
  }

  ngOnInit(): void {
    if (!this.username) {
      this.message = '⚠️ No se recibió un usuario válido.';
      return;
    }

    // 🧠 Login: pedir código directamente
    if (this.modo === 'login') {
      this.message = 'Ingrese el código 2FA generado por su aplicación.';
      return;
    }

    // 🧠 Setup: verificar si ya tiene 2FA activo
    this.loading = true;
    this.authenticatorService.get2FAStatus(this.username).subscribe({
      next: (res: any) => {
        this.tiene2FA = !!res.activo;
        this.loading = false;

        if (this.tiene2FA) {
          this.message = 'Este usuario ya tiene 2FA activado. Puede desactivarlo si lo desea.';
        } else {
          this.message = 'Presione "Generar QR" para activar su autenticación 2FA.';
        }
      },
      error: (err: any) => {
        console.error('❌ Error consultando estado 2FA:', err);
        this.loading = false;
        this.message = 'Error consultando estado del 2FA.';
      }
    });
  }

  // 🔹 Generar QR (solo si no está activo)
  generate2FA(): void {
    if (this.modo !== 'setup' || this.tiene2FA) return;

    this.loading = true;
    this.authenticatorService.generate2FA(this.username).subscribe({
      next: (res: any) => {
        this.qrImage = res.qr;
        this.secret = res.secret;
        this.message = 'Escanee el QR con su aplicación Authenticator y luego verifique el código.';
        this.loading = false;
      },
      error: (err: any) => {
        console.error('❌ Error generando QR:', err);
        this.message = err.error?.message || 'Error al generar el código 2FA.';
        this.loading = false;
      }
    });
  }

  // 🔹 Verificar código (activar 2FA o validar login)
  verificarCodigo(): void {
    if (!this.codigo.trim()) {
      this.message = 'Ingrese un código válido.';
      return;
    }

    this.loading = true;

    if (this.modo === 'login') {
      // === FLUJO LOGIN ===
      this.authenticatorService.verifyLogin2FA(this.username, this.codigo).subscribe({
        next: (res: any) => {
          if (res.token) {
            this.authService.setToken(res.token);
            this.message = '2FA verificado correctamente ✅';
            this.dialogRef.close('success');
          } else {
            this.message = res.message || 'Código incorrecto ❌';
          }
          this.loading = false;
        },
        error: (err: any) => {
          console.error('❌ Error verificando 2FA (login):', err);
          this.message = err.error?.message || 'Error al verificar el código.';
          this.loading = false;
        }
      });
    } else {
      // === FLUJO SETUP ===
      if (!this.secret) {
        this.message = 'Primero genere su código QR.';
        this.loading = false;
        return;
      }

      this.authenticatorService.verify2FA(this.username, this.codigo, this.secret).subscribe({
        next: (res: any) => {
          this.message = res.msg || '2FA activado correctamente ✅';
          this.verified = !!res.ok;

          if (res.ok) {
            this.tiene2FA = true;
            this.dialogRef.close('activado');
          }

          this.loading = false;
        },
        error: (err: any) => {
          console.error('❌ Error verificando 2FA (setup):', err);
          this.message = err.error?.message || 'Código incorrecto ❌';
          this.loading = false;
        }
      });
    }
  }

  // 🔹 Desactivar (solo si está activo)
  desactivar2FA(): void {
    if (!this.tiene2FA || this.modo !== 'setup') return;

    this.loading = true;
    this.authenticatorService.disable2FA(this.username).subscribe({
      next: (res: any) => {
        this.message = res.msg || '2FA desactivado correctamente 🚫';
        this.verified = false;
        this.qrImage = null;
        this.secret = null;
        this.tiene2FA = false;
        this.loading = false;
      },
      error: (err: any) => {
        console.error('❌ Error desactivando 2FA:', err);
        this.message = err.error?.message || 'Error al desactivar 2FA';
        this.loading = false;
      }
    });
  }

  cerrarModal(): void {
    this.dialogRef.close();
  }
}
